export * from './types/types';
export * from './wrappers/wrappers';
export { FormlyValidationMessage } from './formly.validation-message';
export { FormlyBootstrapModule } from './ui-bootstrap.module';



// WEBPACK FOOTER //
// ./src/ui-bootstrap/src/ui-bootstrap.ts